/**
 * Text button component
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { fontSize } from "utils/utils"
import ButtonBase from "@material-ui/core/ButtonBase"
import CircularProgress from "@material-ui/core/CircularProgress"
import Translate from "components/Translate/container"

const StyledButton = styled(ButtonBase)`
  && {
    padding: ${props => (props.padding ? props.padding : "0 10px")};
    margin: ${props => (props.withmargin ? "10px 10px 10px 0" : 0)};
    height: 30px;
    pointer-events: ${props => (props.disabled ? "none" : "inherit")};
    background: ${props =>
      props.disabled
        ? props.theme.buttons["linkDisabled"].background
        : props.theme.buttons[props.name].background};
    font-weight: ${props =>
      props.attrs && props.attrs.bold ? "bold" : "normal"}
    
    ${props =>
      props.size === "sm"
        ? fontSize("buttonLabel")
        : fontSize("buttonLabelSmall")}
    color: ${props =>
      props.disabled
        ? props.theme.buttons["linkDisabled"].color
        : props.theme.buttons[props.name].color};
    letter-spacing: ${props =>
      props.narrow || (props.attrs && props.attrs.narrow) ? "2px" : "2.8px"} ;
    text-transform: uppercase;
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    span.label {
      border-bottom: ${props =>
        props.disabled
          ? "1px dotted " + props.theme.buttons["linkDisabled"].color
          : "1px dotted " + props.theme.buttons[props.name].color};
    }

    :hover {
      color: ${props =>
        props.disabled
          ? props.theme.buttons["linkDisabled"].color
          : props.theme.buttons.hover[props.name].color};

      span.label {
        border-bottom: ${props =>
          props.disabled
            ? "1px dotted " + props.theme.buttons["linkDisabled"].color
            : "1px dotted " + props.theme.buttons.hover[props.name].color};
      }

    }

    :focus {
      outline: 2px solid #015ECC !important;
    }
  }
`

export const ThemeButton = props => {
  return (
    <StyledButton {...props}>
      {props.loading ? (
        <CircularProgress size={22} style={{ color: "white" }} thickness={5} />
      ) : (
        <span className={"label"}>
          <Translate>{props.label}</Translate>
        </span>
      )}
    </StyledButton>
  )
}

ThemeButton.defaultProps = {
  name: "link",
}

ThemeButton.propTypes = {
  attrs: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  nomargin: PropTypes.bool,
}

export default ThemeButton
